import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';
import arrow from '../../../assets/images/svgs/icons/arrow_down.svg';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		return {
			step: state.step,
			results: state.results,
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class EconomicalScoreTrackerFourPlayerTutorial extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	poolVal (currentValue = 0, poolResources = 0, multiplier = 0) {

		return (currentValue + poolResources) * multiplier;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { currentValue, window, unit, multiplier = 1, isTime = false, poolName = 'Pot' } = this.props;

		const max = (window.current && window.current.answers && window.current.answers.range) ? window.current.answers.range.max : null;

		const baseInvestment = (
			window.current &&
			window.current.answers &&
			window.current.answers.baseInvestment
		) ? window.current.answers.baseInvestment : null;

		const poolResources = (
			window.current &&
			window.current.answers &&
			window.current.answers.poolResources
		) ? window.current.answers.poolResources : null;

		const playerAvatar = buildAvatar(this.props, false);
		const yourScore = isTime ? ((max - currentValue) * 100) : (currentValue * -1);
		const poolVal = this.poolVal(parseInt(currentValue), parseInt(poolResources), parseInt(multiplier)) || poolResources * multiplier;

		return (max) ? (
			<div className={'eco-score-tracker__standard'}>
				<div className={'eco-score-tracker__standard__group-wrap'}>
					<EconomicalScoreTrackerPlayer score={yourScore}
																				unit={unit}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={parseInt(baseInvestment['player-2']) * -1}
																				unit={unit}
																				imgSrc={players['player-2']} />
					<EconomicalScoreTrackerPlayer score={parseInt(baseInvestment['player-3']) * -1}
																				unit={unit}
																				imgSrc={players['player-3']} />
					<EconomicalScoreTrackerPlayer score={parseInt(baseInvestment['player-4']) * -1}
																				unit={unit}
																				imgSrc={players['player-4']} />
				</div>

				<img className={'eco-arrow'}
						 src={arrow} />

				<div className={'eco-pool'}>
					<span>{poolName}</span>
					€{poolVal}
				</div>

				<img className={'eco-arrow'}
						 src={arrow} />

				<div className={'eco-score-tracker__standard__group-wrap'}>

					<EconomicalScoreTrackerPlayer score={Math.round((poolVal / 4) - currentValue)}
																				imgSrc={playerAvatar} />
					<EconomicalScoreTrackerPlayer score={Math.round((poolVal / 4) - parseInt(baseInvestment['player-2']))}
																				imgSrc={players['player-2']} />
					<EconomicalScoreTrackerPlayer score={Math.round((poolVal / 4) - parseInt(baseInvestment['player-3']))}
																				imgSrc={players['player-3']} />
					<EconomicalScoreTrackerPlayer score={Math.round((poolVal / 4) - parseInt(baseInvestment['player-4']))}
																				imgSrc={players['player-4']} />
				</div>
			</div>
		) : null;
	}
}
